

export type RangeSliderValue = {
  start: number,
  end: number,
} | null
